import styled from "styled-components";
import { FancyTitle } from "./components/fancyTitle";
import { FlexContainer, MainContainer } from "./components/mainContainer";
import { VerticalLine } from "./components/lines";
import { useTraduzioniQuery } from "../../generated/graphql";
const Container = styled(MainContainer)`
  padding-top: 30px;
  padding-bottom: 20px;
  background-color: #a2a087;
  &::before {
    background-color: #142425;
  }
  &::after {
    background-color: #142425;
  }
`;
const FxContainer = styled(FlexContainer)`
  background-color: #a2a087;

  ${VerticalLine} {
    background-color: #051f204d;
    margin-top: -15px;
  }
`;
const SponsorContainers = styled.div`
  display: flex;
  flex-direction: row;
  gap: 80px;
  justify-content: space-around;
  align-items: center;
  padding: 20px 100px;

  img {
    object-fit: contain;
    height: 100%;
    max-height: 80px;
    max-width: 200px;
  }
  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
`;
export function Sponsors() {
  const { data } = useTraduzioniQuery();

  return (
    <FxContainer>
      <Container>
        <FancyTitle
          text={data?.traduzioniVarie?.nostriPartner || ""}
          inverted
        />
        <SponsorContainers>
          <img src="/kum/sponsors/bernardo.webp"></img>
          <img src="/kum/sponsors/iper.webp"></img>
          <img src="/kum/sponsors/maserati.webp"></img>
        </SponsorContainers>
      </Container>
    </FxContainer>
  );
}
